import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import bgImg from "../../assets/landing/SubmitSection/submit-bg.jpg";
import badgeImg from "../../assets/landing/SubmitSection/badge-promo.png";
import slideImg from "../../assets/landing/bg-slide-1.jpg";

const SubmitSection = () => {
  return (
    <Box
      sx={{
        marginTop: "100px",
        position: "relative",
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(${slideImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        margin: "auto",
        height: "600px",
        textAlign: "center",
        display: "flex", // ✅ ADD THIS
        alignItems: "center", // ✅ Center vertically
        justifyContent: "center",
      }}
    >
      {/* Content Card with bgImg */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: { xl: "60%", lg: "80%", md: "85%", sm: "90%", xs: "85%" },
          mx: "auto",
          height: "400px",
          px: { xs: 3, sm: 4 },
          py: { xs: 5, sm: 6 },
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderRadius: 2,
          boxShadow: 4,
          backdropFilter: "blur(2px)",
          alignSelf: "center",
        }}
      >
        {/* Promo Badge Inside Card */}
        <Box
          sx={{
            position: "absolute",
            top: 10,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
          }}
        >
          <Box
            component="img"
            src={badgeImg}
            alt="Promo Badge"
            sx={{
              width: { xs: 200, sm: 200 },
              height: "auto",
            }}
          />
        </Box>

        {/* Subtitle */}
        <Typography
          variant="h5"
          sx={{
            mb: 4,
            fontWeight: "normal",
            fontSize: { xs: "1.2rem", sm: "1.5rem" },
            color: "white",
          }}
          mt={25}
        >
          Subscribe to our Newsletter
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            fontSize: { xs: "1rem", sm: "1.1rem" },
            maxWidth: 500,
            mx: "auto",
            color: "white",
          }}
        >
          Sign up to receive exclusive deals and promos
        </Typography>

        {/* Email Form */}
        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: { xs: "row" },
            gap: 0.1,
            maxWidth: 500,
            mx: "auto",
          }}
        >
          <TextField
            fullWidth
            placeholder="Enter Your Email"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "rgba(255,255,255,0.95)",
                borderRadius: 0,
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#31B44B",
                },
              },
              "& .MuiInputBase-input": {
                py: 2,
              },
            }}
          />
          <Box
            type="submit"
            variant="contained"
            sx={{
              px: 4,
              py: 2,
              backgroundColor: "#31B44B",
              color: "white",
              borderRadius: 0,
              fontWeight: "bold",
              textTransform: "uppercase",
              fontSize: "1rem",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "#232323",
              },
              cursor: "pointer",
            }}
          >
            Submit
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SubmitSection;
